import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "../lib/api";
import { logError } from "../lib/logger";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null); // null = checking, false = logged out

  useEffect(() => {
    let active = true;
    api
      .get("/auth/me")
      .then((res) => {
        if (active) setUser(res.data);
      })
      .catch((error) => {
        if (error.response?.status !== 401) {
          logError("Auth session check failed:", error);
        }
        if (active) setUser(false);
      });
    return () => {
      active = false;
    };
  }, []);

  const loginSuccess = useCallback((data) => {
    setUser(data.user);
  }, [setUser]);

  const logout = useCallback(async () => {
    try {
      await api.post("/auth/logout");
    } catch (error) {
      logError("Logout request failed:", error);
    }
    setUser(false);
  }, [setUser]);

  return (
    <AuthContext.Provider value={{ user, setUser, loginSuccess, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
